import lightbox from './helpers/lightbox.js'
import mediaQueries from './helpers/media-queries.js'
import globals from './globals.js'

import rootStyle from './styles/root.style'
import globalStyle from './styles/global.style'
import baseStyle from './styles/base.style'
import textStyle from './styles/text.style'
import layoutStyle from './styles/layout.style'
import uiStyle from './styles/ui.style'
import wpStyle from './styles/wp.style'

const loadedComponents = []
const fetchComponents = function() {
  // if in wp editor load every block
  if (window.wp) {
    import('./components/accordion/accordion.js')
    import('./components/banner/banner.js')
    import('./components/boxes/boxes.js')
    import('./components/boxes-alt/boxes-alt.js')
    import('./components/brands/brands.js')
    import('./components/cards/cards.js')
    import('./components/case-histories/case-histories.js')
    import('./components/career-form/career-form.js')
    import('./components/contact-form/contact-form.js')
    import('./components/content/content.js')
    import('./components/content-boxes/content-boxes.js')
    import('./components/download/download.js')
    import('./components/footer/footer')
    import('./components/hero/hero.js')
    import('./components/hero-brand/hero-brand.js')
    import('./components/history/history.js')
    import('./components/icon-boxes/icon-boxes.js')
    import('./components/image-map/image-map.js')
    import('./components/images-slider/images-slider.js')
    import('./components/info/info.js')
    import('./components/info-alt-box/info-alt-box.js')
    import('./components/info-bar/info-bar.js')
    import('./components/info-cards/info-cards.js')
    import('./components/info-box/info-box.js')
    import('./components/info-columns/info-columns.js')
    import('./components/info-overlay/info-overlay.js')
    import('./components/logos/logos.js')
    import('./components/map/map.js')
    import('./components/map-pins/map-pins.js')
    import('./components/performances/performances.js')
    import('./components/posts-grid/posts-grid.js')
    import('./components/posts-slider/posts-slider.js')
    import('./components/post-related/post-related.js')
    import('./components/post-top/post-top.js')
    import('./components/products-grid/products-grid.js')
    import('./components/team/team.js')
    import('./components/values/values.js')
    import('./components/video-box/video-box.js')
  }
  else {
    const components = document.querySelectorAll('[data-component]')
    Array.from(components).forEach(function(el) {
      const componentName = el.tagName.replace(/^sovema-/i, '').toLowerCase()
      if (!loadedComponents.includes(componentName)) {
        // cannot dinamically import modules 
        if (componentName === 'accordion') {
          import('./components/accordion/accordion.js')
        }
        if (componentName === 'banner') {
          import('./components/banner/banner.js')
        }
        if (componentName === 'boxes') {
          import('./components/boxes/boxes.js')
        }
        if (componentName === 'boxesalt') {
          import('./components/boxes-alt/boxes-alt.js')
        }
        if (componentName === 'brands') {
          import('./components/brands/brands.js')
        }
        if (componentName === 'cards') {
          import('./components/cards/cards.js')
        }
        if (componentName === 'chistories') {
          import('./components/case-histories/case-histories.js')
        }
        if (componentName === 'cform') {
          import('./components/contact-form/contact-form.js')
        }
        if (componentName === 'cvform') {
          import('./components/career-form/career-form.js')
        }
        if (componentName === 'content') {
          import('./components/content/content.js')
        }
        if (componentName === 'contentboxes') {
          import('./components/content-boxes/content-boxes.js')
        }
        if (componentName === 'download') {
          import('./components/download/download.js')
        }
        if (componentName === 'footer') {
          import('./components/footer/footer.js')
        }
        if (componentName === 'hero') {
          import('./components/hero/hero.js')
        }
        if (componentName === 'herobrand') {
          import('./components/hero-brand/hero-brand.js')
        }
        if (componentName === 'history') {
          import('./components/history/history.js')
        }
        if (componentName === 'iconboxes') {
          import('./components/icon-boxes/icon-boxes.js')
        }
        if (componentName === 'imagemap') {
          import('./components/image-map/image-map.js')
        }
        if (componentName === 'imagesslider') {
          import('./components/images-slider/images-slider.js')
        }
        if (componentName === 'info') {
          import('./components/info/info.js')
        }
        if (componentName === 'ioverlay') {
          import('./components/info-overlay/info-overlay.js')
        }
        if (componentName === 'infoaltbox') {
          import('./components/info-alt-box/info-alt-box.js')
        }
        if (componentName === 'infobar') {
          import('./components/info-bar/info-bar.js')
        }
        if (componentName === 'infocards') {
          import('./components/info-cards/info-cards.js')
        }
        if (componentName === 'infobox') {
          import('./components/info-box/info-box.js')
        }
        if (componentName === 'infocols') {
          import('./components/info-columns/info-columns.js')
        }
        if (componentName === 'logos') {
          import('./components/logos/logos.js')
        }
        if (componentName === 'map') {
          import('./components/map/map.js')
        }
        if (componentName === 'mappins') {
          import('./components/map-pins/map-pins.js')
        }
        if (componentName === 'performances') {
          import('./components/performances/performances.js')
        }
        if (componentName === 'postsgrid') {
          import('./components/posts-grid/posts-grid.js')
        }
        if (componentName === 'postsslider') {
          import('./components/posts-slider/posts-slider.js')
        }
        if (componentName === 'postrelated') {
          import('./components/post-related/post-related.js')
        }
        if (componentName === 'posttop') {
          import('./components/post-top/post-top.js')
        }
        if (componentName === 'pgrid') {
          import('./components/products-grid/products-grid.js')
        }
        if (componentName === 'team') {
          import('./components/team/team.js')
        }
        if (componentName === 'top') {
          import('./components/top/top.js')
        }
        if (componentName === 'values') {
          import('./components/values/values.js')
        }
        if (componentName === 'vbox') {
          import('./components/video-box/video-box.js')
        }
      }
    })
  }
  import('./components/phase-index/phase-index.js')
  import('./components/mobile-menu/mobile-menu.js')
  import('./components/overlay/overlay.js')
}

if (document.readyState === 'loading') {
  document.addEventListener('readystatechange', function readyStateChangeListener() {
    fetchComponents()
    document.removeEventListener('readystatechange', readyStateChangeListener)
  })
} else {
  fetchComponents()
}

if (window.wp) {
  document.adoptedStyleSheets = [
    rootStyle,
    globalStyle,
    baseStyle,
    wpStyle,
    textStyle,
    layoutStyle,
    uiStyle
  ]

  if (window.acf) {
    window.acf.add_filter('color_picker_args', function(args){
      args.palettes = ['#1b998b', '#ffbb44', '#004467', '#ef7d00', '#FFFFFF']
      return args
    })
  }
} else {
  document.adoptedStyleSheets = [
    rootStyle,
    globalStyle,
    baseStyle,
    textStyle,
    layoutStyle,
    uiStyle
  ]
}

lightbox.init()

Object.keys(globals.mediaQueries).forEach(key => {
  mediaQueries.add(key, globals.mediaQueries[key])
})
